import React from 'react';
import ReactPlayer from 'react-player';

import RotatingGrid from 'components/images/RotatingGrid';
import ResponsiveImage from 'components/images/ResponsiveImage';
import {
  BrandItem,
  BrandRow,
  BlackSlide,
  BigText,
  MedText,
  PhotoRow,
  Row,
  ScrollSection,
  PlayerWrapper,
  SectionCaption
} from '../styles';

import { brandArray } from 'data/home';
import { communityGrid } from 'data/rotatingImages';

const generateBrandArray = () => {
  const rows = [];
  let cols = [];

  brandArray.forEach((brand, idx) => {
    cols.push(
      <BrandItem
        key={`brand-item-${idx}`}
        href={brand.url}
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src={brand.logo}
          alt={`${brand.alt} logo`}
          className={`logo ${brand.increaseSize && 'large-logo'}`}
        />
        <ResponsiveImage srcPath={brand.background} imgAlt={brand.alt} imgClass="background" />
      </BrandItem>
    );

    if ((idx + 1) % 3 === 0) {
      rows.push(<BrandRow key={`brand-row-${rows.length}`}>{cols}</BrandRow>);
      cols = [];
    }
  });

  return rows;
};

const SectionTwo = ({ revealed }) => {
  return (
    <React.Fragment>
      <BlackSlide className="swiper-slide" revealed={revealed >= 9}>
        <h1 className="quote">
          "In Downtown Los Angeles, ROW DTLA has continued to take shape, transforming 32 acres into
          an all-encompassing iconic destination. It is a growing collective of globally recognized
          shops, restaurants and innovative offices that are spread over six buildings to create
          their own unique L.A. environment."
        </h1>
        <span className="credit">LA MAGAZINE</span>
      </BlackSlide>
      <ScrollSection className="swiper-slide" paddingLeft="160px" revealed={revealed >= 10}>
        <PhotoRow>
          <ResponsiveImage
            srcPath="/images/pages/home/section_2/ROWDTLA_retail-brochure_section2_1"
            imgAlt="test"
          />
        </PhotoRow>
        <Row height="45%">
          <BigText className="black-500">
            The perfect mix of LA's
            <br />
            progressive merchants,
            <br />
            lauded restaurateurs
            <br />
            and curated events.
          </BigText>
        </Row>
      </ScrollSection>
      <ScrollSection className="swiper-slide" revealed={revealed >= 11}>
        <PhotoRow>
          <ResponsiveImage
            srcPath="/images/pages/home/section_2/ROWDTLA_retail-brochure_section2_2"
            imgAlt="test"
          />
        </PhotoRow>
        <Row height="45%">
          <MedText className="grey-400">
            In good company, ROW DTLA is
            <br />
            home to LA’s most
            <br />
            dynamic and “on the pulse”
            <br />
            companies.
          </MedText>
        </Row>
      </ScrollSection>
      <ScrollSection
        className="swiper-slide"
        paddingRight="0"
        paddingBottom="120px"
        revealed={revealed >= 12}
        spaceBetween
      >
        {generateBrandArray()}
        <SectionCaption style={{ marginLeft: '5vw' }}>Featured Merchants</SectionCaption>
      </ScrollSection>
      <ScrollSection className="swiper-slide" revealed={revealed >= 13}>
        <ResponsiveImage
          srcPath="/images/pages/home/section_2/ROWDTLA_retail-brochure_section2_3"
          imgAlt="test"
        />
      </ScrollSection>
      <ScrollSection className="swiper-slide" revealed={revealed >= 14}>
        <PlayerWrapper>
          <ReactPlayer
            className="react-player"
            width="100%"
            height="100%"
            url="https://vimeo.com/357861605"
            playing
            controls
            light="/video/player/rowdtla_video_preview_retail.jpg"
          />
        </PlayerWrapper>
      </ScrollSection>
      <ScrollSection className="swiper-slide" paddingRight="120px" revealed={revealed >= 15}>
        <PhotoRow>
          <ResponsiveImage
            srcPath="/images/pages/home/section_2/ROWDTLA_retail-brochure_section2_4"
            imgAlt="test"
          />
        </PhotoRow>
        <Row height="45%">
          <BigText className="grey-400">
            Effortlessly fulfill your
            <br />
            day-to-day essentials in
            <br />
            this walkable locale
          </BigText>
        </Row>
      </ScrollSection>
      <ScrollSection className="swiper-slide" paddingRight="120px" revealed={revealed >= 16}>
        <PhotoRow>
          <ResponsiveImage
            srcPath="/images/pages/home/section_2/ROWDTLA_retail-brochure_section2_5"
            imgAlt="test"
          />
        </PhotoRow>
        <Row height="45%">
          <MedText>
            Bespoke boutiques, Michelin-starred
            <br />
            eateries, and curated events catered
            <br />
            to style icons, food connoisseurs, and
            <br />
            entrepreneurial visionaries. Welcome
            <br />
            to LA’s edge.
          </MedText>
        </Row>
      </ScrollSection>
      <ScrollSection className="swiper-slide" paddingRight="180px" revealed={revealed >= 17}>
        <RotatingGrid imgGrid={communityGrid} />
      </ScrollSection>
    </React.Fragment>
  );
};

export default SectionTwo;
